import type { ChangelogEntry } from "../types";

/** Lukk måned meldte alle ukedager som tomme, og viste ikke hvilke dager som manglet. */
export const LUKK_MAANED_HULL_2026_11: ChangelogEntry = {
  id: "2026-11-02-lukk-maaned-hull",
  date: "2026-11-02",
  title: "Lukk måned teller førte timer riktig og viser hvilke dager som mangler",
  summary:
    "Alle som skulle lukke oktober fikk beskjed om 22 dager uten timer. Nå teller føringene igjen, og siden viser hullene øverst i en kalender og i daglista.",
  sections: [
    {
      heading: "Lukk måned",
      items: [
        {
          title: "Førte timer teller med",
          kind: "rettet",
          body: "Siden så ikke føringene dine og meldte derfor alle ukedager som tomme. Føringer rett etter midnatt havner nå også på riktig dag.",
        },
        {
          title: "Kalender over hullene øverst",
          kind: "nytt",
          body: "En kalender over ukedagene viser tomme dager og dager med færre timer enn forventet. Trykk på en dag for å hoppe til den i lista. Er alt ført, får du en bekreftelse.",
        },
        {
          title: "Alle ukedager i daglista",
          kind: "forbedret",
          body: "Lista viser alle ukedager fram til i dag, også de uten timer, gruppert per uke med førte timer mot kapasitet. Tomme dager har «Ny registrering» rett på raden.",
        },
        {
          title: "Du bekrefter timer og fravær når du lukker",
          kind: "forbedret",
          body: "Avhukingen før lukking gjelder nå både timer og fravær. Varselet om hull stopper deg ikke, så du som ikke jobber alle ukedager kan lukke måneden når det du har ført stemmer.",
        },
      ],
    },
  ],
};
